import classes from "./ChartCard.module.css";
import { pieChartPercentageCalculator } from "../util/genPieChartData";

export default function ChartCard({ children, id, data, bName }) {
  // console.log("fffffffffffffffffffff Chart Card");
  // console.log(data);

  let percentageData = pieChartPercentageCalculator(data);
  // console.log(percentageData);

  const backgroundColor = [
    "rgba(79, 60, 220, 1)",
    "rgba(71, 208, 119 )",
    "rgba(255, 206, 86 )",
    "rgba(231, 81, 114, 1)",
    "rgba(224, 20, 64 )",
    "rgba(255, 159, 64 )",
    "rgba(75, 192, 192, 0.8)",
  ];

  // step to exlcude branch name if only one branch is present at all times.
  let branches = JSON.parse(localStorage.getItem("branches"));
  return (
    <div className={`${classes.container} pieContainerBlob`}>
      {branches.length > 1 && <p>{bName}</p>}
      <div className={classes.percentageContainer}>
        <div>
          {percentageData.map((pdata, index) => {
            return (
              <div key={`fds${index}`}>
                <div
                  style={{
                    backgroundColor: `${backgroundColor[index]}`,
                    color: `${backgroundColor[index]}`,
                  }}
                  className={classes.colorBox}
                >
                  hello199
                </div>
                <span>
                  {`${percentageData[index].optionTitle} : ${percentageData[index].percentage}%`}
                </span>
              </div>
            );
          })}
        </div>

        {/* loop ends here */}
      </div>

      {children}
    </div>
  );
}
